import { combineReducers, configureStore } from "@reduxjs/toolkit";
import publicSliceReducer from "./publicSlice";
import authSliceReducer from "./authSlice";
import todoSliceReducer from "./todoSlice";
import thubSliceReducer from "./thubSlice";
import ticketSliceReducer from "./ticketSlice";
import announcementSliceReducer from "./announcementSlice";
import playerSliceReducer from "./playerSlice";
import chatSliceReducer from './chatSlice'
import companyAdminPanelReducer from './companyAdminPanelSlice'
import superAdminPanelReducer from './superAdminSlice'
import profileReducer from './profileSlice'
import mediaReducer from './mediaSlice'

const combineReducer = combineReducers({
  public: publicSliceReducer,
  auth: authSliceReducer,
  todo: todoSliceReducer,
  thub: thubSliceReducer,
  ticket: ticketSliceReducer,
  announcement: announcementSliceReducer,
  player: playerSliceReducer,
  chat: chatSliceReducer,
  companyAdminPanel: companyAdminPanelReducer, 
  superAdminPanel: superAdminPanelReducer,
  profile: profileReducer,
  media: mediaReducer,

});

const store = configureStore({
  reducer: combineReducer,
});

export default store;
